
export const featuredProjects = [
  {
    id: 'tommy-hilfiger-mens',
    title: "Tommy Hilfiger Men's Store",
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/3b76ab16b5c7e3e9cdad9923dfd6a68a.jpeg',
    slug: 'tommy-hilfiger-mens-store'
  },
  {
    id: 'chanel-womens-shoes',
    title: "Chanel Women's Shoes",
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/544e2c85bade52d24a19e6ed8b27b132.jpeg',
    slug: 'chanel-womens-shoes'
  },
  {
    id: 'eileen-fisher',
    title: 'Eileen Fisher',
    image: 'https://images.squarespace-cdn.com/content/v1/5d1c6d56cbbe8700019631e5/1567620517286-IRWPRWR7D0L47IKMS24C/e4.jpg',
    slug: 'eileen-fisher'
  },
  {
    id: 'chanel-accessories',
    title: 'Chanel Accessories',
    image: 'https://images.squarespace-cdn.com/content/v1/5d1c6d56cbbe8700019631e5/1582221490089-LJEY7MFFAM2T5X6ZJ40B/BEL03591.jpg',
    slug: 'chanel-accessories'
  },
  {
    id: 'max-mara-marella',
    title: 'Max Mara Marella',
    image: 'https://images.squarespace-cdn.com/content/v1/5d1c6d56cbbe8700019631e5/1582221600031-KDRB7AD28KHXT6KXCNXR/BEL03722.jpg',
    slug: 'max-mara-marella'
  },
  {
    id: 'max-mara-studio',
    title: 'Max Mara Studio',
    image: 'https://images.squarespace-cdn.com/content/v1/5d1c6d56cbbe8700019631e5/1582221738409-GECJDMLOBHPQ27AAHZNY/BEL03751.jpg',
    slug: 'max-mara-studio'
  }
];

export const allProjects = [
  ...featuredProjects,
  {
    id: 'max-mara-weekend',
    title: 'Max Mara Weekend',
    image: 'https://images.squarespace-cdn.com/content/v1/5d1c6d56cbbe8700019631e5/1582221670816-JMYLBT42CQ4YGQEBLGAZ/BEL03791.jpg',
    slug: 'max-mara-weekend'
  },
  {
    id: 'ralph-lauren-home',
    title: 'Ralph Lauren Home',
    image: 'https://images.squarespace-cdn.com/content/v1/5d1c6d56cbbe8700019631e5/1582221814159-T2A1O89GV05X6BVBC8CN/BEL03806.jpg',
    slug: 'ralph-lauren-home'
  },
  {
    id: 'burberry-flagship',
    title: 'Burberry Flagship',
    image: 'https://public.readdy.ai/ai/img_res/a77aad2f04f1b4fb1720416b41a95334.jpg',
    slug: 'burberry-flagship'
  }
];
